export const usersQueryKey = ['users']
export const usersQueryKeyWithParams = (
  params: (string | number | (number | string)[])[]
) => [...usersQueryKey, params]

export const fuzzySearchUserKey = (search: string, limit: number) => [
  'commandPalette',
  'fuzzySearchUser',
  search,
  limit,
]
